module.exports = __webpack_public_path__ + "static/forecast-62408f9d8758a84b6d5aa62ea96c3050.mp4";